import { render, staticRenderFns } from "./OrderItemList.vue?vue&type=template&id=3ea023c8&scoped=true"
import script from "./OrderItemList.vue?vue&type=script&lang=js"
export * from "./OrderItemList.vue?vue&type=script&lang=js"
import style0 from "./OrderItemList.vue?vue&type=style&index=0&id=3ea023c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea023c8",
  null
  
)

export default component.exports